import React, { useRef, useState } from 'react';
import { useAddCompalinWebMutation } from './CompalinWebSlice';

const AddCompalinWeb = () => {
    const [addCompalinweb, setAddCompalinweb] = useState({ name: "", number: "", text: "", complain_suggestion: "", street: "", property_name: "", full_address: "" });
    const [addNewCompalin, { isLoading }] = useAddCompalinWebMutation()

    const refClose = useRef(null);

    const handleChange = (e) => setAddCompalinweb({ ...addCompalinweb, [e.target.name]: e.target.value });


    const handleClick = async (e) => {
        e.preventDefault();
        try {
            const xyz = await addNewCompalin({ name: addCompalinweb.name, number: addCompalinweb.number, text: addCompalinweb.text, complain_suggestion: addCompalinweb.complain_suggestion, street: addCompalinweb.street, property_name: addCompalinweb.property_name, full_address: addCompalinweb.full_address }).unwrap()
            setAddCompalinweb({ name: "", number: "", text: "", complain_suggestion: "", street: "", property_name: "", full_address: "" })
            refClose.current.click()
        }
        catch (e) {
            console.log(e, "Error");
            console.error(e)
        }
    }

    return (
        <>
            <button type="button" className="Add_button bg-left-navabr  text-light  btn btn-secondary" data-bs-toggle="offcanvas" data-bs-target="#depOffCanvas" aria-controls="depOffCanvas"><i className="fa fa-plus" aria-hidden="true"></i> Add Compalin Web</button>

            <div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="1" id="depOffCanvas" aria-labelledby="depOffCanvas">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvas1Label">Add Compalin Web</h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref={refClose}></button>
                </div>
                <div className="offcanvas-body">
                    <div>
                        <form className="row g-3">
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="name"
                                    value={addCompalinweb.name}
                                    onChange={handleChange}
                                    placeholder=""
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Number
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="number"
                                    name="number"
                                    value={addCompalinweb.number}
                                    onChange={handleChange}
                                    placeholder=""
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Text
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="text"
                                    name="text"
                                    value={addCompalinweb.text}
                                    onChange={handleChange}
                                    placeholder=""
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Complain Suggestion
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="complain_suggestion"
                                    name="complain_suggestion"
                                    value={addCompalinweb.complain_suggestion}
                                    onChange={handleChange}
                                    placeholder=""
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Street
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="street"
                                    name="street"
                                    value={addCompalinweb.street}
                                    onChange={handleChange}
                                    placeholder=""
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Property Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="property_name"
                                    name="property_name"
                                    value={addCompalinweb.property_name}
                                    onChange={handleChange}
                                    placeholder=""
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Full Address
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="full_address"
                                    name="full_address"
                                    value={addCompalinweb.full_address}
                                    onChange={handleChange}
                                    placeholder=""
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12">
                                <button type="submit" className="btn btn-ff9b44 btn-block btn-round"
                                    onClick={handleClick}
                                disabled={!(addCompalinweb.name)}
                                >
                                    {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddCompalinWeb;
